import React from 'react';
import ContentHubDetailPage from './ContentHubDetailPage';

const NewsArticle: React.FC = () => <ContentHubDetailPage kind="news" />;

export default NewsArticle;
